import React, { Fragment } from "react";
import { BOX_SIZE, COLOR_EMPTY } from "../../../constants";

const PADDING = 0.5;
const SIZE = BOX_SIZE - PADDING * 2;

const CellBackground = ({ x, y, color = COLOR_EMPTY }) => (
  <Fragment>
    <rect
      x={x + PADDING}
      y={y + PADDING}
      width={SIZE}
      height={SIZE}
      rx="5.68"
      ry="5.68"
      fill={color}
    />
    <rect
      x={x + PADDING + 4.37}
      y={y + PADDING + 4.37}
      width={SIZE - 4.37 * 2}
      height={SIZE - 4.37 * 2}
      rx="7.5"
      ry="7.5"
      fill="#fff"
    />
  </Fragment>
);

export default CellBackground;



// WEBPACK FOOTER //
// ./src/components/Cells/Cells/CellBackground.js